enum EButtonTypeForm {
  button = "button",
  submit = "submit",
}

export default EButtonTypeForm;
